module.exports = "<svg viewBox=\"0 0 14.8 12.1\"><path class=\"Sound__svg-wave\" d=\"M8.7,9.1v-1c1.1,0,2.1-0.9,2.1-2.1C10.8,4.9,9.8,4,8.7,4V3c1.7,0,3.1,1.4,3.1,3.1S10.4,9.1,8.7,9.1z\"></path><path class=\"Sound__svg-wave\" d=\"M8.7,12.1v-1c2.8,0,5.1-2.3,5.1-5.1S11.5,1,8.7,1V0c3.3,0,6.1,2.7,6.1,6.1C14.8,9.4,12,12.1,8.7,12.1z\"></path><polygon points=\"2.1,4.2 2.1,7.8 7.2,11.2 7.2,0.8 \"></polygon><rect x=\"0.2\" y=\"4.2\" class=\"st2\" width=\"2.9\" height=\"3.7\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/sound/svg/ico.svg
// module id = MSy7
// module chunks = 0